"use client";

import React from "react";
import { IamUser, TenantDetailsRow, MenuItem, TenantFlatMenus } from "@patron/data-access-server";
import dynamic from "next/dynamic";

// This prevents the NotificationContextProvider from being rendered on the server
const DynamicNotificationProvider = dynamic(() => import("./NotificationContextProvider"), {
  ssr: false,
});

interface AppContextproviderProps {
  children: React.ReactNode | React.ReactPortal | boolean | null | undefined;
  userData?: IamUser;
  enabledFeatures: string[];
  menuItems?: MenuItem[];
  flatMenuItems?: TenantFlatMenus[];
  tenantCompanyDetails?: TenantDetailsRow;
  appVersion?: string;
  queryProcessing?: boolean;
  isFullScreen?: boolean;
}

interface AppContextState {
  userData?: IamUser;
  enabledFeatures?: string[];
  menuItems?: MenuItem[];
  tenantFlatMenuItems?: TenantFlatMenus[];
  tenantCompanyDetails?: TenantDetailsRow;
  appVersion?: string;
  queryProcessing?: boolean;
}

interface LocalScreenState {
  isFullScreen?: boolean;
  fullScreenStyle?: React.CSSProperties;
}

export interface ContextState {
  localAppState: AppContextState;
  setLocalAppState: React.Dispatch<React.SetStateAction<AppContextState>>;
  localScreenSate: LocalScreenState;
  setLocalScreenSate: React.Dispatch<React.SetStateAction<LocalScreenState>>;
}
export const AppContext = React.createContext<ContextState>({
  localAppState: {},
  setLocalAppState: () => null,
  localScreenSate: {},
  setLocalScreenSate: () => null,
});

export const AppContextProvider = (props: AppContextproviderProps) => {
  const { userData, tenantCompanyDetails, enabledFeatures, menuItems, flatMenuItems, appVersion, isFullScreen } = props;
  const fullScreenStyle = {
    position: "fixed" as const,
    top: 60,
    left: 10,
    right: 10,
    bottom: 10,
    width: "99vw",
    height: "94vh",
    zIndex: 9998,
    overflow: "auto" as const,
  };

  const [localAppState, setLocalAppState] = React.useState<AppContextState>({
    userData: userData,
    menuItems: menuItems,
    tenantFlatMenuItems: flatMenuItems,
    enabledFeatures: enabledFeatures,
    tenantCompanyDetails: tenantCompanyDetails,
    appVersion: appVersion,
    queryProcessing: false,
  });

  const [localScreenSate, setLocalScreenSate] = React.useState<LocalScreenState>({
    isFullScreen: isFullScreen,
    fullScreenStyle: fullScreenStyle,
  });

  const context: ContextState = {
    localAppState,
    setLocalAppState,
    localScreenSate,
    setLocalScreenSate,
  };
  return (
    <AppContext.Provider value={context}>
      <DynamicNotificationProvider endpoint={"/notification/subscribe"}> {props.children}</DynamicNotificationProvider>
    </AppContext.Provider>
  );
};
// export AppContextProvider;
